import Project from '@/models/Project'

let HiddenProjects : Project[] = []
const HiddenProjectKey = 'hidden-projects'

// Uses Project[] rather than pids so that we can display a list of hidden projects
export function GetHiddenProjects() : Project[]
{
	if (HiddenProjects.length > 0)
	{
		return HiddenProjects;
	}

	let data = localStorage.getItem(HiddenProjectKey);
	if (data == null)
		return [];
	
	let parsed = JSON.parse(data) as Project[];
	if (parsed)
	{
		let projects : Project[] = []
		for(let i = 0; i < parsed.length; ++i)
		{
			let p = new Project;
			Object.assign(p, parsed[i]);
			projects.push(p);
		}
		HiddenProjects = projects;
		return projects;
	}
	return [];
}

export function SaveHiddenProjects(projects : Project[])
{
	// This could just be a string array of IDs but it would break backwards compatibility
	let copy : Project[] = projects.map((p) => { let q = new Project(); q.id = p.id; return q; }); // just the id
	console.log(copy);
	localStorage.setItem(HiddenProjectKey, JSON.stringify(copy));
	HiddenProjects = copy;
}

export function IsProjectHidden(project : Project) : boolean
{
	if (!project)
	{
		console.trace();
		return false;
	}
	let hidden = GetHiddenProjects();
	for(let i = 0; i < hidden.length; ++i)
	{
		if (hidden[i].id.trim().toLowerCase() == (project.id || project.pid).trim().toLowerCase())
		{
			return true;
		}
	}
	return false;
}

export function HideProject(project : Project)
{
	if (IsProjectHidden(project))
		return;

	let hidden = GetHiddenProjects();
	hidden.push(project);
	SaveHiddenProjects(hidden);
}

export function UnhideProject(project : Project)
{
	let hidden = GetHiddenProjects();
	for(let i = 0; i < hidden.length; ++i)
	{
		console.log(`Trying ${hidden[i]}`);
		if (hidden[i].pid.trim().toLowerCase() == project.pid.trim().toLowerCase())
		{
			console.log('FOUND!');
			hidden.splice(i, 1);
			break;
		}
	}
	SaveHiddenProjects(hidden);
}